import React, { useEffect, useState } from 'react';
import ProductCarousel from './common/productCarousel.jsx';
import useFetch from './common/useFetch.jsx';

/**
 * Generates the My Premium Products component
 *
 * @returns {JSX.Element}
 * @constructor
 */
const MyPremiumProducts = () => {
	const [data, setData] = useState(null);

	// Options for Slick Carousel
	const options = {
		infinite: false,
		slidesToShow: 7,
		slidesToScroll: 7,
		speed: 500,
		swipeToSlide: true,
		responsive: [
			{
				breakpoint: 1089,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	};

	const getUserProductListServices = '/internal/dynamic-home-api/Ajax/Ajax.php?action=GetUserProductList&limit=20';
	const { response, loading, error } = useFetch(getUserProductListServices);
	const title = <>My<i className="fa-duotone fa-sparkles" aria-hidden="true"></i>Premium<i className="fa-duotone fa-sparkles" aria-hidden="true"></i>
		Content</>;
	let productLabel, url, image;

	/**
	 * Listens for changes in response state.
	 * setData method called when data is response is ready
	 *
	 */
	useEffect(() => {
		if (response !== null) {
			setData(
				Object.entries(response.payload)
					.reduce((premiumProducts, line) => {
						if (line[0] === 'products') {
							line[1].reduce((acc, productItem)=>{
								const item = Object.entries(productItem);

								premiumProducts = [
									...premiumProducts,
									{
										uuid: item[0][0],
										title: item[0][1].title,
										url: item[0][1].url,
										image: item[0][1].image,
										productType: item[0][1].productType
									}
								];
							}, []);
						} else {
							switch (line[0]) {
							case 'hasCourses':
								productLabel = 'All My Courses';
								url = '/my/passes/courses/';
								image = 'https://media1.shmoop.com/heartbeat/courses-icon.png';
								break;
							case 'hasTestPrep':
								productLabel = 'All My Test Preps';
								url = '/my/passes/testprep/';
								image = 'https://media1.shmoop.com/heartbeat/test_prep_thumbnail-270x113.png';
								break;
							case 'hasRTI':
								productLabel = 'All My RTI\'s';
								url = '/my/passes/testprep/';
								image = 'https://media1.shmoop.com/heartbeat/rti-icon.png';
								break;
							default:
								// DH-360: the payload carries entitlement flags beyond the three
								// tile types (hasHeartbeat, and the DH-358 header-filtering flags
								// hasPBIS/hasACT/hasPSAT/hasSAT/hasAP — more may come). They are
								// not premium-content tiles; rendering them here reused the label
								// of the last matched case ("All My RTI's" x5).
								return premiumProducts;
							}

							if (line[1]) {
								premiumProducts = [
									...premiumProducts,
									{
										uuid: line[0],
										title: productLabel,
										url: url,
										image: image,
										productType: line[0]
									}
								];
							}
						}

						return premiumProducts;
					}, [])
			);
		}
	}, [response]);

	return (
		<div className={'my-premium-products'}>
			<ProductCarousel
				options={options}
				error={error}
				loading={loading}
				data={data}
				title={title}
				alt={'My Premium Content'} />
		</div>
	);
};

export default MyPremiumProducts;
